<!--
 * @Author: your name
 * @Date: 2020-09-10 15:43:26
 * @LastEditTime: 2023-02-02 14:25:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractInfo\contractAchrives\payedWays.vue
-->
<template>
    <div class="payedWays">
        <div class="header">
            <div class="top">
                <div class="top-con">
                    <div class="container">
                        <div class="contract-number">
                            合同编号：{{ contractInfo.contract_number }}
                        </div>
                        <div class="customer-name">
                            {{ contractInfo.engineering_name }}
                        </div>
                        <div class="project-name">
                            {{ contractInfo.client_name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="split"></div>
            <div class="bottom">
                <div class="payway-describe">
                    {{ contractInfo.settlement_mode_and_payment_clause }}
                </div>
            </div>
        </div>
        <div class="block-con">
            <div class="block-item block-mark">
                <div class="tag">
                    标号
                </div>
                <ul>
                    <li
                        v-for="item in contractInfo.contract_price_mark_num_list"
                        :key="item.product_mark_code"
                    >
                        <div class="price">
                            {{ item.product_mark_price }}
                        </div>
                        <div class="num">
                            {{ item.product_mark_num }}
                        </div>
                    </li>
                </ul>
            </div>
            <div class="block-item block-additional">
                <div class="tag">
                    附加型号
                </div>
                <div class="con">
                    <ul>
                        <li
                            v-for="item in contractInfo.contract_price_additional_list"
                            :key="item.additional_model_code"
                        >
                            <div class="price">
                                {{ item.additional_model_price }}
                            </div>
                            <div class="num">
                                {{ item.additional_model }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="block-item block-other" v-if="$store.state.versionMark == 2">
                <div class="tag">
                    其他
                </div>
                <template v-if="contractInfo.contract_price_versions">
                    <span class="content">
                        地泵费<span class="blue">{{ contractInfo.contract_price_versions.ground_pump_price }}</span>元/方，
                        汽车泵费<span class="blue">{{ contractInfo.contract_price_versions.pump_price }}</span>元/方。
                        <span class="item" v-if="contractInfo.contract_price_versions.pump_charge_way===1">
                            单次要货不足<span class="blue">{{ contractInfo.contract_price_versions.pump_min }}</span>方，
                            按<span class="blue">{{ contractInfo.contract_price_versions.pump_add }}</span>方结算。
                        </span>
                        <span class="item" v-if="contractInfo.contract_price_versions.pump_charge_way===2">
                            单次要货不足<span class="blue">{{ contractInfo.contract_price_versions.pump_volumn_less }}</span>方，
                            收取<span class="blue">{{ contractInfo.contract_price_versions.pump_plus_money }}</span>元。
                        </span>
                        <span v-if="contractInfo.contract_price_versions.pumper_money_mode===1">
                            单次泵送不足<span class="blue">{{ contractInfo.contract_price_versions.pumper_volumn_min }}</span>方，
                            收出场费<span class="blue">{{ contractInfo.contract_price_versions.pumper_add_money }}</span>元
                        </span>
                    </span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        contractNumber: {
            type: String,
        },
    },
    data() {
        return {
            contractInfo: {},
        };
    },
    watch: {
        contractNumber(val) {
            if (val) {
                this.handleContractInfo();
            }
        },
    },
    computed: {},
    created() {},
    mounted() {
        if (this.contractNumber) {
            this.handleContractInfo();
        }
    },
    methods: {
        // 处理合同档案信息
        async handleContractInfo() {
            const res = await this.getContractInfo();
            if (res) {
                this.contractInfo = res;
                if (!this.contractInfo.contract_price_mark_num_list) {
                    this.contractInfo.contract_price_mark_num_list = [];
                }
                if (!this.contractInfo.contract_price_additional_list) {
                    this.contractInfo.contract_price_additional_list = [];
                }
            }
        },
        // 根据合同编号获取档案信息
        getContractInfo() {
            const path = '/interfaceApi/sale/contract_archives/get_contract_basic_info/' + this.contractNumber;
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.payedWays
    height 100%
    background #F0F0F0
    overflow-y: auto;
    .header
        min-height 197rpx
        .top
            height 115rpx
            background #2b5dab
            position relative
            .top-con
                background #2b5dab
                padding 0 15rpx
                position absolute
                top 2px
                left 0
                width 100%
                height 100%
            .container
                background #fff
                height 100%
                padding 15rpx 15rpx 5rpx 15rpx
                border-radius 4rpx 4rpx 0 0
        .bottom
            padding 0 15rpx 15rpx 15rpx
            min-height 80rpx
            .payway-describe
                border-radius 0 0 4rpx 4rpx
                background #fff
                font-size 12rpx
                color #666666
                line-height 20rpx
                min-height 80rpx
                padding 0 15rpx 15rpx 15rpx
                box-shadow 0 4px 4px 0px rgba(85, 136, 241, 0.5)
        .split
            background url(./../images/split.png) no-repeat
            height 22rpx
            background-size 100% 100%
        .contract-number
            font-size 16rpx
            color #3495FB
        .customer-name
            font-size 16rpx
            color #333333
            margin 5rpx 0
        .project-name
            font-size 14rpx
            color #666666
        .place-area
            height 22rpx
    .block-con
        padding 15rpx
        .block-item
            padding 50rpx 15rpx 15rpx 15rpx
            background #ffffff
            margin-bottom 10rpx
            position relative
            .tag
                position absolute
                left 0
                top 14rpx
                width 80rpx
                height 25rpx
                border-radius 0 14rpx 14rpx 0
                text-align center
                color #fff
                line-height 25rpx
            .content
                background rgba(85,136,241,0.08)
                padding 0 .1rem
                .item
                    margin-right .05rem
                .blue
                    color #2aaadd
            &.block-other
                font-size 14rpx
            &.block-mark
                padding 50rpx 5rpx 0 15rpx
                .tag
                    background linear-gradient(270deg, #55A7FE 0%, #3E79C5 100%)
                ul
                    overflow hidden
                    li
                        float left
                        width 50rpx
                        margin-right 10rpx
                        margin-bottom 10rpx
                        .price
                            padding 5rpx 0
                            text-align center
                            background rgba(85, 136, 241, 0.12)
                            color #5588F1
                            font-size 14rpx
                        .num
                            font-size 12rpx
                            min-height 20rpx
                            line-height 20rpx
                            background rgba(85, 136, 241, 0.06)
                            text-align center
                            width 100%
            &.block-additional
                padding 50rpx 15rpx 10rpx 15rpx
                .tag
                    background: linear-gradient(270deg, #EFAB54 0%, #FA8C47 100%);
                .con
                    overflow-x auto
                    ul
                        width auto
                        white-space nowrap
                        li
                            display inline-block
                            margin-right 10rpx
                            margin-bottom 10rpx
                            min-width 44rpx
                            .price
                                padding 5rpx 0
                                text-align center
                                background rgba(250, 132, 54, 0.12)
                                color #FA8436
                                font-size 14rpx
                            .num
                                font-size 12rpx
                                height 20rpx
                                line-height 20rpx
                                background rgba(250, 132, 54, 0.06)
                                text-align center
                                padding 0 5rpx
                    &::-webkit-scrollbar /*滚动条整体样式*/
                            width 4px     /*高宽分别对应横竖滚动条的尺寸*/
                            height 4px
                    &::-webkit-scrollbar-thumb /*滚动条里面小方块*/
                        border-radius 4px
                        -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.1)
                        background #d9d7d7
                    &::-webkit-scrollbar-track /*滚动条里面轨道*/
                        -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.1)
                        border-radius 4px
                        background rgba(237,237,237,  0.2)
            &.block-other
                .tag
                    background linear-gradient(270deg, #71C6B0 0%, #4EA496 100%)
                .green
                    color #4EA496
                p
                    font-size 12rpx
</style>
